import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@ann/web-components';
import ModalBase from '../ModalBase';
import { ModalContent, ActionsContainer } from '../Modal.styled';
import ShareModalContent from './ShareModalContent';
import PendingGranteesList from './PendingGranteesList';
import CurrentGranteesList from './CurrentGranteesList';

const ShareModal = observer(({
    isOpen,
    store,
    resourcesStore,
    onClose,
    onShare,
    onAddToPending,
    onUpdatePendingPermission,
    onRemovePending,
    onUpdateGranteePermission,
    onRemoveGrantee,
    usersList
}) => {
    return (
        <ModalBase
            isOpen={isOpen}
            onClose={onClose}
            title={`Share ${store.itemsToShare.length > 1 ? 'Items' : store.itemsToShare[0]?.type === 'folder' ? 'Folder' : 'Document'}`}
        >
            <ModalContent>
                <ShareModalContent
                    itemsToShare={store.itemsToShare}
                    selectedUsers={store.selectedUsers}
                    selectedPermission={store.selectedPermission}
                    currentSelectionType={store.currentSelectionType}
                    privileges={resourcesStore}
                    onUsersChange={store.setSelectedUsers}
                    onPermissionChange={store.setSelectedPermission}
                    onAddClick={onAddToPending}
                    usersList={usersList}
                />

                <PendingGranteesList
                    pendingGrantees={store.pendingGrantees}
                    currentSelectionType={store.currentSelectionType}
                    privileges={resourcesStore}
                    onUpdatePermission={onUpdatePendingPermission}
                    onRemove={onRemovePending}
                />

                <CurrentGranteesList
                    shouldShow={store.shouldShowGranteesList}
                    grantees={resourcesStore.grantees}
                    isLoading={resourcesStore.granteesLoading}
                    currentSelectionType={store.currentSelectionType}
                    privileges={resourcesStore}
                    onUpdatePermission={onUpdateGranteePermission}
                    onRemove={onRemoveGrantee}
                />
            </ModalContent>

            <ActionsContainer>
                {
                    store.pendingGrantees.length > 0 && (
                        <Button
                            label="Share"
                            size="medium"
                            type="primary"
                            onClick={onShare}
                            disabled={store.isLoadingSharing}
                        />
                    )
                }
            </ActionsContainer>
        </ModalBase>
    );
});

export default ShareModal;
